const Menu = {
  "Usuario Casos Especiales": [
    {
      path: "/",
      icon: "fa fa-th",
      title: "Inicio",
    },
    {
      path: "/Alta",
      icon: "fas fa-list-ol",
      title: "Alta",
      children: [
        { path: "/solicitud/inscripcion-regente", title: "Regente" },
        {
          path: "/solicitud/inscripcion-representante",
          title: "Representante Legal",
        },
        {
          path: "/solicitud/inscripcion-medico-veterinario",
          title: "Médico veterinario",
        },
        {
          path: "/comercializador/asociar",
          title: "Comercializador",
        },
      ],
    },
    {
      path: "/solicitud-tramites",
      icon: "fa fa-money-check",
      title: "Solicitud de trámites",
    },
    {
      path: "/tramites",
      icon: "fa fa-clock",
      title: "Consulta de trámites",
    },
    {
      path: "/solicitud-casos-especiales",
      icon: "fa fa-list",
      title: "Casos especiales",
    },
  ],
  Regente: [
    {
      path: "/",
      icon: "fa fa-th",
      title: "Inicio",
    },
    {
      path: "/alta",
      icon: "fas fa-list-ol",
      title: "Alta",
      children: [
        { path: "/solicitud/inscripcion-regente", title: "Regente" },
        {
          path: "/solicitud/inscripcion-representante",
          title: "Representante Legal",
        },
        {
          path: "/solicitud/inscripcion-medico-veterinario",
          title: "Médico veterinario",
        },
        {
          path: "/comercializador/asociar",
          title: "Comercializador",
        },
      ],
    },
    {
      path: "/solicitud-tramites",
      icon: "fa fa-money-check",
      title: "Solicitud de trámites",
    },
    {
      path: "/tramites",
      icon: "fa fa-clock",
      title: "Consulta de trámites",
    },
    {
      path: "/regencia",
      icon: "fas fa-users",
      title: "Regencia",
    },
    {
      path: "/establecimiento",
      icon: "fa fa-building",
      title: "Establecimientos",
      children: [
        { path: "/establecimientos/listado", title: "Trámites" },
        { path: "/establecimientos-activos", title: "Listado" },
        { path: "/asociar-establecimiento", title: "Asociar" },
      ],
    },
    {
      path: "/producto",
      icon: "fa fa-shopping-basket",
      title: "Productos",
      children: [
        { path: "/productos/listado", title: "Trámites" },
        { path: "/productos/activos", title: "Listado" },
        {
          path: "/productos/anotacion-marginal",
          title: "Anotaciones marginales",
        },
        { path: "/productos/certificados", title: "Certificados" },
        { path: "/productos/precertificados", title: "Precertificados" },
        { path: "/productos/baja", title: "Baja inventario" },
      ],
    },
    {
      path: "/movimiento-productos",
      icon: "fa fa-truck",
      title: "Movimientos productos",
      children: [
        {
          path: "/movimientos-productos/mover-producto",
          title: "Mover producto",
        },
        { path: "/movimientos-productos/egresos", title: "Egresos" },
        { path: "/movimientos-productos/ingresos", title: "Ingresos" },
        { path: "/movimientos-productos/inventario", title: "Inventario" },
      ],
    },
    {
      path: "/comercializadores",
      icon: "fa fa-building",
      title: "Comercializadores",
    },
    {
      path: "/reporte-importacion",
      icon: "fa fa-file",
      title: "Importación medicamentos controlados",
      children: [
        {
          path: "/reportar-importacion",
          title: "Generar reporte importación",
        },
        { path: "/reportes-importacion", title: "Reportes importación" },
      ],
    },
    {
      path: "/sustancia-reporte-medicamento-controlado",
      title: " Reportes medicamentos controlados",
      icon: "fas fa-file-excel",
    },
  ],
  "Representante Legal": [
    {
      path: "/",
      icon: "fa fa-th",
      title: "Inicio",
    },
    {
      path: "/alta",
      icon: "fas fa-list-ol",
      title: "Alta",
      children: [
        { path: "/solicitud/inscripcion-regente", title: "Regente" },
        {
          path: "/solicitud/inscripcion-representante",
          title: "Representante Legal",
        },
        {
          path: "/solicitud/inscripcion-medico-veterinario",
          title: "Médico veterinario",
        },
        {
          path: "/comercializador/asociar",
          title: "Comercializador",
        },
      ],
    },
    {
      path: "/solicitud-tramites",
      icon: "fa fa-money-check",
      title: "Solicitud de trámites",
    },
    {
      path: "/tramites",
      icon: "fa fa-clock",
      title: "Consulta de trámites",
    },
    {
      path: "/establecimiento",
      icon: "fa fa-building",
      title: "Establecimientos",
      children: [
        { path: "/establecimientos/listado", title: "Trámites" },
        { path: "/establecimientos-activos", title: "Listado" },
        { path: "/asociar-establecimiento", title: "Asociar" },
      ],
    },
    {
      path: "/producto",
      icon: "fa fa-shopping-basket",
      title: "Productos",
      children: [
        { path: "/productos/listado", title: "Trámites" },
        { path: "/productos/activos", title: "Listado" },
        {
          path: "/productos/anotacion-marginal",
          title: "Anotaciones marginales",
        },
        { path: "/productos/certificados", title: "Certificados" },
        { path: "/productos/precertificados", title: "Precertificados" },
        { path: "/productos/baja", title: "Baja inventario" },
      ],
    },
    {
      path: "/reporte-importacion",
      icon: "fa fa-file",
      title: "Importación medicamentos controlados",
      children: [
        {
          path: "/reportar-importacion",
          title: "Generar reporte importación",
        },
        { path: "/reportes-importacion", title: "Reportes importación" },
      ],
    },
    {
      path: "/sustancia-reporte-medicamento-controlado",
      title: " Reportes medicamentos controlados",
      icon: "fa fa-file",
    },
  ],
  "Médico Veterinario": [
    {
      path: "/",
      icon: "fa fa-th",
      title: "Inicio",
    },
    {
      path: "/recetas-electronicas",
      icon: "fa fa-file-prescription",
      title: "Recetas electrónicas",
      children: [
        {
          path: "/recetas-electronicas/expedir",
          title: "Expedir Receta",
        },
        { path: "/recetas-electronicas/surtir", title: "Surtir Receta" },
        { path: "/recetas-electronicas/expedidas", title: "Recetas Expedidas" },
        { path: "/recetas-electronicas/surtidas", title: "Recetas Surtidas" },
      ],
    }
  ],
  "Comercializador ": [
    {
      path: "/",
      icon: "fa fa-th",
      title: "Inicio",
    },
    {
      path: "/subproductos",
      icon: "fa fa-file-prescription",
      title: "Subproductos",
      children: [
        {
          path: "/subproductos/precertificado-constancia-exportacion",
          title: "Precertificado y/o constancia de exportación",
        },
        {
          path: "/subproductos/autorizacion-de-adquisicion",
          title: "Autorización de adquisición",
        },
      ],
    },
    {
      path: "/comercializador/asociar",
      icon: "fas fa-list-ol",
      title: "Asociar a planta",
    },
  ],
};

export default Menu;
